import clsx from "clsx";
import { IoIosCall } from "react-icons/io";
import { Link } from "react-router-dom";

const ContactFloatingButtons = () => {
    return (
        <>
            {/* <Link
                to="/contact"
                className={clsx(
                    "tw-w-[50px] tw-h-[50px] tw-rounded-full tw-bg-white",
                    "tw-fixed tw-top-[85px] tw-right-8 tw-z-10",
                    "tw-flex tw-items-center tw-justify-center",
                    "tw-border-2 tw-border-[#00213e] !tw-shadow"
                )}
            >
                <IoIosCall className="tw-text-[#00213e] tw-w-8 tw-h-8" />
            </Link> */}
            <a
                href="tel:+917069024240"
                className={clsx(
                    "tw-w-[50px] tw-h-[50px] tw-rounded-full tw-bg-white",
                    "tw-fixed tw-bottom-[106px] tw-right-6 tw-z-10",
                    "tw-flex tw-items-center tw-justify-center",
                    "tw-border-2 tw-border-[#00213e] !tw-shadow"
                )}
            >
                <IoIosCall className="tw-text-[#00213e] tw-w-8 tw-h-8" />
            </a>
        </>
    );
};

export default ContactFloatingButtons;
